<template>
  <div class="title">
    <h5>Course Media</h5>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="input-block">
        <div class="row align-items-center">
          <div class="col-md-12">
            <label class="form-label"
              >Course Thumbnail<span class="text-danger ms-1">*</span></label
            >
          </div>
          <div class="col-md-10">
            <input
              readonly
              type="text"
              class="form-control"
              placeholder="No File Selected"
              :value="thumbnailFileName"
            />
          </div>
          <div class="col-md-2 d-grid">
            <label for="file-upload" class="file-upload-btn text-center"
              >Upload File</label
            >
            <input
              type="file"
              id="file-upload"
              name="file"
              accept="image/*"
              @change="handleFileUpload"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 text-center">
      <div v-if="addCourseForm.thumbnail !== null">
        <img
          :src="thumbnailPreview"
          alt="Preview"
          style="max-height: 150px; object-fit: contain"
        />
      </div>
      <div
        class="upload-img-section d-flex align-items-center justify-content-center"
        id="upload-img-section"
        v-else
      >
        <div class="upload-content">
          <span class="d-flex align-items-center justify-content-center mb-1">
            <i class="isax isax-image5 text-secondary fs-24 text-center"></i>
          </span>
          <p class="text-center fw-medium mb-1">Upload Image</p>
          <span class="text-center"
            >JPEG, PNG, GIF, and WebP formats, up to 2 MB</span
          >
        </div>
      </div>
      <hr class="mt-4 mb-4" />
    </div>
    <!-- <div class="col-md-12">
      <div class="row">
        <div class="col-md-4">
          <div class="input-block-link">
            <label class="form-label"
              >Course Video<span class="text-danger ms-1">*</span></label
            >
            <input
              type="file"
              class="form-control"
              accept="video/*"
              @change="handleVideoUpload"
            />
          </div>
        </div>
        <div class="col-md-8">
          <div class="input-block-link">
            <label class="form-label">&nbsp;</label>
            <input
              type="text"
              class="form-control"
              placeholder="External URL Link"
            />
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="col-md-12">
      <div class="input-block">
        <div class="row align-items-center">
          <div class="col-md-12">
            <label class="form-label"
              >Course Video<span class="text-danger ms-1">*</span></label
            >
          </div>
          <div class="col-md-10">
            <input
              type="text"
              class="form-control"
              placeholder="No File Selected"
              :value="videoFileName"
              readonly
            />
          </div>
          <div class="col-md-2 d-grid">
            <label for="file-upload" class="file-upload-btn text-center"
              >Upload Video</label
            >
            <input
              type="file"
              id="file-upload"
              name="file"
              accept="video/*"
              @change="handleVideoUpload"
              style="display: none"
            />
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="col-md-12">
      <div class="position-relative">
        <a
          href="https://www.youtube.com/embed/1trvO6dqQUI"
          id="openVideoBtn"
          target="_blank"
        >
          <img
            class="img-fluid rounded"
            src="@/assets/img/course/add-course-1.jpg"
            alt="img"
          />
          <div class="play-icon">
            <i class="fa-solid fa-play"></i>
          </div>
        </a>
      </div>
      <div id="videoModal">
        <div class="modal-content1">
          <span class="close-btn" id="closeModal">&times;</span>
          <iframe id="youtubeIframe" allowfullscreen></iframe>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { useCourseDataStore } from "@/stores/course/course-data-store";
import { computed, ref, onBeforeUnmount, watch } from "vue";
import { useAuthStore } from "@/stores/auth-store";
import { useSharedStore } from "@/stores/shared-store";

export default {
  data() {
    return {
      Coursevideo: ["External URL", "Youtube", "External", "Vimeo"],
      previewUrl: null,
    };
  },
  setup() {
    const sharedStore = useSharedStore();
    const CourseDataStore = useCourseDataStore();
    const authStore = useAuthStore();
    const addCourseForm = computed(() => CourseDataStore.addCourseForm);
    const objectUrl = ref(null);
    const BASE_URL = authStore.Url + "/media/";

    const thumbnailPreview = computed(() => {
      const thumbnail = addCourseForm.value.thumbnail;

      if (objectUrl.value) {
        return objectUrl.value;
      }

      if (thumbnail instanceof File || thumbnail instanceof Blob) {
        objectUrl.value = URL.createObjectURL(thumbnail);
        return objectUrl.value;
      }

      if (typeof thumbnail === "string") {
        if (thumbnail.startsWith("http")) {
          return thumbnail;
        } else {
          return BASE_URL + thumbnail;
        }
      }

      return null;
    });

    const thumbnailFileName = computed(() => {
      const thumbnail = addCourseForm.value.thumbnail;

      if (!thumbnail) {
        return "";
      }

      if (thumbnail instanceof File || thumbnail instanceof Blob) {
        return thumbnail.name;
      }

      if (typeof thumbnail === "string") {
        // Ambil nama file dari path string seperti: "course/thumbnails/filename.png"
        return thumbnail.split("/").pop();
      }

      return "";
    });

    watch(
      () => addCourseForm.value.thumbnail,
      (newVal) => {
        if (objectUrl.value) {
          URL.revokeObjectURL(objectUrl.value);
          objectUrl.value = null;
        }

        if (newVal instanceof File || newVal instanceof Blob) {
          objectUrl.value = URL.createObjectURL(newVal);
        }
      }
    );

    // Revoke URL to prevent memory leak

    onBeforeUnmount(() => {
      if (objectUrl.value) {
        URL.revokeObjectURL(objectUrl.value);
      }
    });

    return {
      CourseDataStore,
      addCourseForm,
      thumbnailPreview,
      thumbnailFileName,
      sharedStore,
    };
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        // validasi tipe mime
        if (!file.type.startsWith("image/")) {
          this.sharedStore.showError("Hanya file gambar yang diperbolehkan!");
          event.target.value = ""; // reset input
          return;
        }

        this.CourseDataStore.addCourseForm.thumbnail = file;
      }
    },
  },
};
</script>
